import React from 'react';
import { Button } from '@common-ui/ui';
import { setTemporaryImageIds } from '../../../store/slices/imagesSlice';
import { useAppDispatch } from '../../../store/configureStore';
import routerPathEnum from '../../../enums/routerPathEnum';
import { useHistory } from 'react-router';

export default function ReturnToWorkItem() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const buttonHandler = () => {
    dispatch(setTemporaryImageIds([]));
    history.push({ pathname: routerPathEnum.WORK_ITEM });
  };

  if (window?.location !== window?.parent?.location) {
    return (
      <Button color="secondary" variant="outlined" sx={button} onClick={buttonHandler}>
        Return To Work Item
      </Button>
    );
  } else {
    return <div />;
  }
}

const button = {
  background: 'white',
  '&:hover': {
    background: '#d3d3d3',
  },
};
